export default "__VITE_ASSET__DY18nPah__"